<template>
    <div>
        <h1 class="mb-4 font-active">payment options</h1>
                <p>Friendly Diamonds offers a variety of payment methods for purchasing lab diamonds and diamond jewelry to provide a smooth and hassle-free buying experience. All prices on our website are in US dollars.
                <br><br>
                Customers can pay the entire amount in one go using any of the listed payment methods or they can choose Split The Payment method to split their total order into two payments using separate debit or credit cards. The first payment must be at least 51% of the total, and the remaining amount can be paid with another card. 
                
                </p>
                <h2 class="mb-0">Modes of Payment</h2> 
                <h3>Credit Card & Debit Card</h3>
                <p>We accept Visa, MasterCard, American Express, as well as other major credit cards & debit cards. If a payment fails, the order will be automatically canceled. The failure may happen due to insufficient funds in their bank account or if the amount charged exceeds their credit limit. Customers are advised to contact their bank in case their payment is rejected and try again once the bank approves the transaction.</p>

                <h3>Afterpay</h3>
                <p>Afterpay is a convenient and flexible payment option where customers can split their total order value into four easy payments over a period of six weeks by selecting this option during checkout.</p>

                <h3>Affirm Monthly Payments</h3>
                <p>
                    Affirm Financing allows multiple monthly repayment plans with rates starting as low as 0% APR for well-qualified buyers. The process is simple, quick, and easy. Customers can fill out their basic information to receive a real time decision on the amount of financing they are approved for, with absolutely no hidden costs. <br><br>
                    Offer is subject to credit check and approval. Minimum monthly payments are required. The interest rate will be based on credit and is subject to an eligibility check. Options are based on the total purchase amount and there might be a requirement for a down payment. For more information, visit the <a target="_blank" rel="nofollow noopener" href="https://www.affirm.com/how-it-works"> Affirm Payments </a> website.
                    <br><br>
                    
                </p>
                <p class="red">Please Note: This financing option is only available for shipping within the United States.</p>
                
                <h3>Splitit</h3>
                <p>Customers can also pay for their purchases with an existing credit card by splitting costs into interest and fee-free monthly payments without additional registrations or applications with Splitit.</p><br>
                <h4>How Does It Work?</h4>
                <ul>
                    <li>Pay during the course of 2, 3, 4, or 6 months with no fees & 0% interest.</li>
                    <li>The first month’s installment is charged to the applied credit card. To ensure all debts are paid off, the entire purchase amount is held in reserve on the card at no cost.</li>
                    <li>The credit card will be charged monthly, and the same amount will be deducted from the credit line hold.</li>
                    <li>Monthly payments will appear on the credit card statement, but the remaining amount on hold will not show up as debt.</li>
                </ul>
                <h4>To Be Eligible, Customers Will Need To Provide:</h4>
                <ul>
                    <li>A valid credit card (VISA or MasterCard)</li>
                    <li>Sufficient funds on the card to cover the entire purchase</li>
                </ul>
                <p>For more information, please visit the <a target="_blank" rel="nofollow noopener" href="https://www.splitit.com/"> Splitit </a> website.</p>



                <h3>PayPal</h3>
                <p>
                    Pay securely on PayPal using debit and credit card information to checkout. For this payment mode, customers need to log into their PayPal account to complete their transaction. PayPal also offers short-term, interest-free monthly payments and other special financing options that buyers can use to Buy Now and Pay Later. Pay Later offers are included with PayPal Checkout at no additional cost. <br><br>
                    Get a <b>free PayPal guarantee</b> when shopping on friendlydiamonds.com through PayPal - Get authentic certified diamonds and jewelry, or get your 100% money back. 
                </p>


                <h3>Bank Wire</h3>
                <p> 
                    All Bank Wire payments across the United States enjoy a 2% discount pre-tax on their cart value. Once a Bank Wire order is placed, an email with the details of the wire transfer information is sent to the customer's registered email ID. Upon making the wire transfer, the customer is requested to send an email to <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> with the payment receipt. <br><br>
                    Banks may take a few days to process the Bank Wire transaction. Customers will receive an order confirmation email once we have received the payment at our end. Please note that the order will only be processed once the payment is received. The shipping timeline for the order starts from the date of payment received.
                </p>
                <br>
                <p>
                    <strong>Our bank wire details are mentioned below:</strong> <br>
                    <strong>Company Name:</strong> Friendly Diamonds Inc <br>
                    <strong>Address:</strong> 20 W 47th St, Suite #716, New York, NY 10036 <br>
                    <strong>Bank:</strong> Chase Bank <br>
                    <strong>Account Number:</strong> 713905039 <br>
                    <strong>Routing Number:</strong> 021000021 
                </p> 
                <br>
                <p class="red">Please note that a Bank Wire transfer and an ACH transfer are different. Friendly Diamonds does not accept ACH transfers.</p>
    </div>
</template>

<script setup>
   const { $country } = useNuxtApp()
</script>

<style scoped>
.red{
    color: rgb(251, 8, 8);
}
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h2 {
    font-size: 24px;
    font-weight: 500;
    color: #212529;
    margin: 30px 0 20px;
}
h3 {
    font-size: 22px;
    font-weight: 500;
    color:#353535;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h2{
        font-size: 18px;
    }
    h3 {
        font-size: 16px;
    }
    p {
        font-size: 14px;
    }
    ul li {
        font-size: 14px;
    }
}
</style>